import { useEffect } from "react";
import moment from "moment";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import $ from "jquery";
import { TextField, InputLabel, FormControl } from "@mui/material";
import { DateTimeFormat } from "../common/DateFormat";
interface Props {
  setDateRangeChange: (data: any) => void;
  dateRange: any;
  isDisabled?: boolean;
  onlyAtFirstDetailLoading?: boolean;
  onlyAtSecondDetailLoading?: boolean;
  fromPage?: string;
  name?: string;
}

function DateRangeWithTime({
  setDateRangeChange,
  dateRange,
  isDisabled,
  onlyAtFirstDetailLoading,
  onlyAtSecondDetailLoading,
  fromPage,
  name,
}: Props) {

  const restrictToSevenDaysPages: any = ["timeseries"]; //Restricted these pages to seven days selection
  const inptuName = name ? name : "datetimes"
  useEffect(() => {
    const initDateRangePicker = () => {
      $(`input[name="${inptuName}"]`).daterangepicker({
        timePicker: true,
        maxDate: moment().format(DateTimeFormat()),
        // startDate: moment().startOf('hour'),
        startDate: dateRange.startDate,
        // endDate: moment().startOf('hour').add(2, 'hour'),
        endDate: dateRange.endDate,
        locale: {
          format: DateTimeFormat(),
        },
      });

      $(`input[name="${inptuName}"]`).on(
        "apply.daterangepicker",
        (ev: any, picker: any) => {
          //Restrict to 7 days
          const totalDays = picker.endDate.diff(picker.startDate, "days");
          if (totalDays > 7 && restrictToSevenDaysPages.includes(fromPage)) {
            // Add error message inside datepicker
            const container = picker.container.find(".drp-buttons");
            container.find(".error-message").remove(); // Remove any existing error messages
            container.append(
              '<div class="error-message" style="color:red;text-align:center;margin-top:5px;">Please select 7 days or less</div>'
            );
            picker.show(); // Keep the date picker open
            return;
          } else {
            // Remove error message if date range is valid
            picker.container.find(".error-message").remove();
          }
          setDateRangeChange({
            ...dateRange,
            startDate: picker.startDate,
            endDate: picker.endDate,
          });
        }
      );
    };

    initDateRangePicker();

    if (
      onlyAtFirstDetailLoading === false ||
      onlyAtSecondDetailLoading === false
    ) {
      initDateRangePicker();
    }
  }, [
    onlyAtFirstDetailLoading,
    onlyAtSecondDetailLoading,
    dateRange,
    fromPage,
    setDateRangeChange,
  ]);

  return (
    <div>
      <TextField
        disabled={isDisabled}
        sx={{
          background: "#FFFFFF",
        }}
        id="outlined-basic"
        fullWidth
        name={inptuName}
        label="Date Range"
        variant="outlined"
        type="text"
      />
    </div>
  );
}
export default DateRangeWithTime;
